<template>
  <div class="vacancy-responses-card-header">
    <div class="vacancy-responses-card-header__image-block">
      <img v-if="vacancyImage" :src="vacancyImage" alt="">
      <img v-else src="../../assets/img/png/no-photo-placeholder.png" alt="">
    </div>

    <div class="vacancy-responses-card-header__vacancy-title-wrap">
      <div class="account-vacancies-responses__description-text">{{ $tMyResponses('Vacancy') }}</div>
      <div class="vacancy-responses-card-header__title">
        <router-link-modified
          class="text-decoration-none text-dark"
          target="_blank"
          :to="'/vacancies/v/' + responseVacancy.vacancy_slug"
        >
          {{ vacancyTitle }}
        </router-link-modified>
      </div>
    </div>

    <div class="vacancy-responses-card-header__data-item">
      <div class="account-vacancies-responses__description-text">{{ $tMyResponses('Relevant to') }}</div>
      <div>{{ responseVacancy.relevant_until }}</div>
    </div>

    <div class="vacancy-responses-card-header__data-item">
      <div class="account-vacancies-responses__description-text">{{ $tMyResponses('Places remaining') }}</div>
      <div>{{ responseVacancy.places_count }}</div>
    </div>

    <div class="vacancy-responses-card-header__data-item">
      <div class="account-vacancies-responses__description-text">{{ $tMyResponses('Total responses') }}</div>
      <div>
        <span>{{ responseVacancy.sent_resumes_count }}</span>
        <div v-if="responseVacancy.has_new" class="account-vacancies-responses__active-dot"></div>
      </div>
    </div>

    <div class="vacancy-responses-card-header__extend-btn-wrap">
      <button
        class="vacancy-responses-card__extend-btn base-btn base-btn--small base-btn--outline-grey"
        :class="{ '_inverted-icon': isExtendedCard }"
        @click.stop="$emit('arrow-down-click')"
      >
        <BaseSvg name="ico-arrow-down" width="0.9rem" height="0.5rem"  />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VacancyResponsesCardHeader',
  props: {
    isExtendedCard: {
      type: Boolean,
      required: true,
    },
    responseVacancy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    vacancyTitle() {
      const title = this.responseVacancy.vacancy[1].name;
      if (title?.length > 100) return title.slice(0, 97) + '...';
      return title;
    },
    vacancyImage() {
      return this.responseVacancy.vacancy[3].images?.[0]?.path_web;
    },
  },
};
</script>
